/* eslint-disable no-param-reassign */
/* eslint-disable no-nested-ternary */
import { call, put, takeEvery, select } from "redux-saga/effects";
import { getRequest, postRequest } from "../../helpers/Api";
import { types, actions } from "../reducers/deviceClockIn";

function* fetchDevice({ payload: { id } }) {
  try {
    const response = yield call(getRequest, {
      url: `/device/${id}`,
      authorized: false,
    });

    if (response.status === 404) {
      yield put(actions.fetchDeviceFailed("Device not found"));
      return;
    }
    if (response.status >= 400) {
      yield put(actions.fetchDeviceFailed(response.message || "Something went wrong"));
      return;
    }

    yield put(actions.fetchDeviceSucceeded(response));
  } catch (err) {
    yield put(actions.fetchDeviceFailed(err.message || "Internal server error"));
  }
}

// function* validateLocation({ payload: { location } }) {
//   try {
//     const { id } = yield select((state) => state.qrCodeClockIn.qrCode);
//     const response = yield call(postRequest, {
//       url: `/device/${id}/contains-location`,
//       authorized: false,
//       jsonContentType: true,
//       body: JSON.stringify(location),
//     });

//     if (response.status === 204) {
//       const geo = yield call(getRequest, {
//         url: `https://geolocation-db.com/json/`,
//         fullUrl: true,
//         authorized: false,
//         jsonContentType: true,
//       });
//       yield put(
//         actions.validateLocationSucceeded(
//           geo && typeof geo === "object" && geo.IPv4 ? geo.IPv4 : null
//         )
//       );
//     } else if (response.status >= 400) {
//       yield put(actions.validateLocationFailed(response.message));
//     }
//   } catch (err) {
//     yield put(actions.validateLocationFailed(err.message || "Internal server error"));
//   }
// }

// function* clockInLogin({ payload: { data, onSuccess, onFailure } }) {
//   try {
//     const response = yield call(postRequest, {
//       url: `/device-clock-in/login`,
//       authorized: false,
//       jsonContentType: true,
//       body: JSON.stringify(data),
//     });

//     if (response.status >= 200 && response.status < 300) {
//       localStorage.setItem("DEVICE_CLOCK_IN_TOKEN", response.token);
//       yield put(actions.clockInLoginSucceeded(response.employee));
//       onSuccess();
//     } else if (response.status >= 400) {
//       yield put(actions.clockInLoginFailed(response.message));
//       onFailure();
//     }
//   } catch (err) {
//     yield put(actions.clockInLoginFailed(err.message || "Internal server error"));
//     onFailure();
//   }
// }

// function* clockInCheckToken() {
//   try {
//     const token = localStorage.getItem("DEVICE_CLOCK_IN_TOKEN");
//     if (token) {
//       const response = yield call(getRequest, {
//         url: `/device-clock-in/check-token`,
//         authorized: false,
//         jsonContentType: true,
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });
//       if (response.status >= 200 && response.status < 300) {
//         yield put(actions.clockInLoginSucceeded(response));
//       } else if (response.status >= 400) {
//         yield put(actions.clockInCheckTokenFailed());
//         localStorage.removeItem("DEVICE_CLOCK_IN_TOKEN");
//       }
//     } else {
//       yield put(actions.clockInCheckTokenFailed());
//     }
//   } catch (err) {
//     yield put(actions.clockInCheckTokenFailed());
//   }
// }

// function* clockInLogout({ payload: { redirect } }) {
//   try {
//     if (redirect) {
//       yield put(actions.clockInLogoutSucceeded());
//       window.location.href = "/thank-you";
//     } else {
//       localStorage.removeItem("DEVICE_CLOCK_IN_TOKEN");
//       window.location.reload();
//     }
//   } catch (err) {
//     yield put(actions.clockInLogoutFailed(err.message || "Internal server error"));
//   }
// }

function* deviceCheckIfClockedIn() {
  try {
    const { user } = yield select((state) => state.qrCodeClockIn);
    const { device } = yield select((state) => state.deviceClockIn);
    const response = yield call(getRequest, {
      url: `/device/${device.id}/${user.id}/shift`,
      jsonContentType: true,
      authorized: false,
    });
    if (response.status >= 200 && response.status < 300) {
      yield put(actions.checkIfDeviceClockedInSucceeded(response));
    } else if (response.status === 404 && response.message === "No shift found") {
      yield put(actions.checkIfDeviceClockedInSucceeded(null));
    } else if (response.status >= 400) {
      yield put(actions.checkIfDeviceClockedInFailed(response.message));
    }
  } catch (err) {
    yield put(actions.checkIfDeviceClockedInFailed(err.message || "Internal server error"));
  }
}

function* deviceClockIn({ payload: { onSuccess } }) {
  try {
    const { user } = yield select((state) => state.qrCodeClockIn);
    const { device } = yield select((state) => state.deviceClockIn);
    const response = yield call(postRequest, {
      url: `/device/${device.id}/${user.id}/shift/start`,
      authorized: false,
      jsonContentType: true,
    });

    if (response.status >= 200 && response.status < 300) {
      yield put(actions.clockInDeviceSucceeded(response));
      if (onSuccess) {
        onSuccess();
      }
    } else if (response.status >= 400) {
      yield put(actions.clockInDeviceFailed(response.message));
    }
  } catch (err) {
    yield put(actions.clockInDeviceFailed(err.message || "Internal server error"));
  }
}

function* deviceClockOut({ payload: { onSuccess } }) {
  try {
    const { user } = yield select((state) => state.qrCodeClockIn);
    const { device } = yield select((state) => state.deviceClockIn);
    yield call(postRequest, {
      // backend was on pills
      url: `/device/${device.id}/${user.id}/shift/stop`,
      authorized: false,
      jsonContentType: true,
    });

    yield put(actions.clockOutDeviceSucceeded());
    if (onSuccess) {
      onSuccess();
    }
  } catch (err) {
    yield put(actions.clockOutDeviceFailed(err.message || "Internal server error"));
  }
}

export default function* sagas() {
  yield takeEvery(types.REQUEST_FETCH_DEVICE, fetchDevice);
  // yield takeEvery(types.REQUEST_VALIDATE_LOCATION, validateLocation);
  yield takeEvery(types.REQUEST_DEVICE_CHECK_IF_CLOCKED_IN, deviceCheckIfClockedIn);
  yield takeEvery(types.REQUEST_DEVICE_CLOCK_IN, deviceClockIn);
  yield takeEvery(types.REQUEST_DEVICE_CLOCK_OUT, deviceClockOut);
}
